export default {
  SET_file(state, value) {
    state.file = value;
  },
};
